import { dscvrApi } from '@/shared/api';

export const useRefreshMatricaWalletsMutation = async () => {
  return dscvrApi.matrica.refreshMatricaWallets();
};
